import { Component, ViewChild, ElementRef, AfterViewInit, OnInit, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { LlModelsService } from '../ll-models.service';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlScrollpaneService } from '../ll-scrollpane.service';
import { Subscription } from 'rxjs';

interface LoanRecordElement {
  LOANGROUPID: number;
  LOANELEMENTID: number;
  ELEMENTORDER: number;
  ELEMENTLABEL: string;
  ELEMENTVALUE: number | string;
  ELEMENTNOTE: string;
  ELEMENTDESCRIPTION: string;
  ELEMENTPLUSMINUS: 'plus' | 'minus' | 'none';
  ELEMENTVALUETYPE: 'dollars' | 'decimal' | 'integer' | 'none' | 'date' | 'dropdown';
  ELEMENTREQUIREDYESNO: 'Yes' | 'No';
  ELEMENTCANEDITYESNO: 'Yes' | 'No';
  BBC_CLIENTSIG_REQUIREDYESNO: 'Yes' | 'No';
  BBCCLIENTSIGNATUREYESNO: 'Yes' | 'No';
  BBCCLIENTSIGNATURENAME: string;
  BBC_APPROVESIG_REQUIREDYESNO:'Yes' | 'No';
  BBCLENDERAPPROVEDYESNO: 'Yes' | 'No';
  BBCLENDERAPPROVALNAME: string;
  ELEMENTCODE: string;
  THROUGHDATELIMIT: string;
  BBCLANGUAGE: string;
  BBCAPPROVALLANGUAGE: string;
  BBCLOGONAME: string;
  COLLATCONFIGMSG: string;
  CLIENTSIG: string;
  CLIENTTITLE: string;
  LOANMODELBBCRECORDID: number;
  CLIENTSIGNINLLYESNO: 'Yes' | 'No';
  LENDERAPPROVEINLLYESNO: 'Yes' | 'No';
  DROPCHOICES?: string;
}

interface LoanRecordGroup {
  LOANGROUPID: number;
  GROUPNAME: string;
  GROUPORDER: number;
  GROUPREQUIREDYESNO: 'Yes' | 'No';
  SINGLEELEMENTYESNO: 'Yes' | 'No';
  GROUPCANEDITYESNO: 'Yes' | 'No';
}

interface LoanElement {
  LOANELEMENTID: number;
  LOANGROUPID: number;
  ELEMENTORDER: number;
  ELEMENTLABEL: string;
  ELEMENTDESCRIPTION: string;
  ELEMENTCODE: string;
  ELEMENTCANEDITYESNO: 'Yes' | 'No';
  ELEMENTPLUSMINUS: 'plus' | 'minus' | 'none';
  ELEMENTREQUIREDYESNO: 'Yes' | 'No';
  ELEMENTFORMULA: string;
  ELEMENTTEMPLATEYESNO: 'Yes' | 'No';
  ELEMENTVALUETYPE: 'dollars' | 'decimal' | 'integer' | 'none' | 'date' | 'dropdown';
  ELEMENTUNDERLINEDYESNO: 'Yes' | 'No';
  BBCLANGUAGE: string;
  BBCAPPROVALLANGUAGE: string;
  BBCLOGONAME: string;
  COLLATCONFIGMSG: string;
  CLIENTSIG: string;
  CLIENTTITLE: string;
  LOANMODELBBCRECORDID: number;
  CLIENTSIGNINLLYESNO: 'Yes' | 'No';
  LENDERAPPROVEINLLYESNO: 'Yes' | 'No';
  DROPCHOICES?: string;
}

interface Bundle {
  function: string;
  showObj: boolean;
  canAdd: boolean;
  canFilter: boolean;
  canEditRecords: boolean;
  canEditElements: boolean;
  canLockValues: boolean;
  canLock: boolean;
  canDelete: boolean;
  canApproveBBC: boolean;
  approved_BBC: boolean;
  canSignBBC: boolean;
  signed_BBC: boolean;
  configLock: boolean;
  valueLock: boolean;
  saved: boolean;
  showClientSig: boolean;
  showApprovalSig: boolean;
  valuesChanged: boolean;
  BBC_throughDate_num: string;
  BBC_MONTHENDDATE_NUM: string;
  BBCSignatureName: string;
  BBCApprovalName: string;
  parentW: number;
  parentH: number;
  remainingX: number;
  remainingY: number;
  remainingW: number;
  remainingH: number;
  spX: number;
  spY: number;
  spH: number;
  spW: number;
  records?: LoanRecordElement[];
  groups?: LoanRecordGroup[];
  elements?: LoanElement[];
  CONTACTFIRST?: string;
  CONTACTLAST?: string;
  BBCLANGUAGE: string;
  BBCAPPROVALLANGUAGE: string;
  BBCLOGONAME: string;
  COLLATCONFIGMSG: string;
  signatureInputValue: string;
  titleInputValue: string;
  sigAndTitle: boolean;
  LOANMODELBBCRECORDID: number;
  clientSignRequired: boolean;
  lenderApproveRequired: boolean;
}

@Component({
  selector: 'll-loanmgmt-loanrecord',
  templateUrl: './ll-loanmgmt-loanrecord.component.html',
  styleUrls: ['./ll-loanmgmt-loanrecord.component.css']
})
export class LlLoanmgmtLoanRecordComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('mainDiv_ll_loanmgmt_loanrecord') mainDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('signatureInput') signatureInput!: ElementRef<HTMLInputElement>;
  @Output() selectElement = new EventEmitter<{ LOANELEMENTID: number, LOANGROUPID: number }>();
  private eventSubscriptionNewView?: Subscription;
  public groupRecords: Record<number, LoanRecordElement[]> = {};
  public formattedValues: Record<number, string> = {};
  public showPopover: boolean = false;
  public popoverGroupId: number | null = null;
  public tooltipVisibility: Record<number, boolean> = {};
  public tooltipPosition: { x: number, y: number } = { x: 0, y: 0 };
  public popoverPosition: { x: number, y: number } = { x: 0, y: 0 };
  public showSignaturePopup: boolean = false;
  public sigType: string = '';

  private isMouseInPopover: boolean = false;
  private isMouseInSignaturePopup: boolean = false;
  private signatureInputValue: string = '';
  private tempRecordIdCounter: number = -1;

  // Pre-computed dropdown options (key = LOANELEMENTID)
  public dropdownOptions: Record<number, string[]> = {};

  public bundle: Bundle = {
    function: '',
    showObj: true,
    canAdd: false,
    canFilter: false,
    canEditRecords: false,
    canEditElements: false,
    canLockValues: false,
    canLock: false,
    canDelete: false,
    canApproveBBC: false,
    approved_BBC: false,
    canSignBBC: false,
    signed_BBC: false,
    configLock: true,
    valueLock: false,
    saved: false,
    valuesChanged: false,
    showClientSig: false,
    showApprovalSig: false,
    BBC_throughDate_num: '0',
    BBC_MONTHENDDATE_NUM :'0',
    BBCSignatureName: '',
    BBCApprovalName: '',
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 0,
    remainingW: 0,
    remainingH: 0,
    spX: 0,
    spY: 70,
    spH: 0,
    spW: 0,
    records: [],
    CONTACTFIRST: '',
    CONTACTLAST: '',
    BBCLANGUAGE: '',
    BBCAPPROVALLANGUAGE: '',
    BBCLOGONAME: '',
    COLLATCONFIGMSG: '',
    signatureInputValue: '',
    titleInputValue: '',
    sigAndTitle: false,
    LOANMODELBBCRECORDID: 0,
    clientSignRequired: false,
    lenderApproveRequired: false,
  };

  private readonly today = new Date();
  readonly formattedDate: string = this.today.toISOString().split('T')[0];

  constructor(
    private readonly llModelsService: LlModelsService,
    private readonly llPermissionsService: LlPermissionsService,
    private readonly LlScrollpaneService: LlScrollpaneService,
    private readonly cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initializeComponent();
      this.cdr.detectChanges();
    }, 0);
  }

  ngOnDestroy(): void {
    this.eventSubscriptionNewView?.unsubscribe();
  }

  private initializeComponent(): void {
    this.bundle.function = this.mainDiv.nativeElement.parentElement?.id ?? '';
    if (this.bundle.function === 'll_company_models_sp') {
      this.bundle.function = 'loanSetting';
      this.bundle.spY = 10;
    } else {
      this.bundle.function = 'bbc';
    }
    this.bundle.canAdd = this.llPermissionsService.check('editLoanRecords');
    if (this.bundle.function === 'loanSetting') {
      this.bundle.canEditElements = this.llPermissionsService.check('editLoanElements');
      this.bundle.canEditRecords = this.llPermissionsService.check('editLoanElements');
    } else {
      this.bundle.canEditElements = this.llPermissionsService.check('editBBCElements');
      this.bundle.canEditRecords = this.llPermissionsService.check('editBBCValues');
      this.bundle.canDelete = this.llPermissionsService.check('deleteBBC');
    }

    this.bundle.canApproveBBC = this.llPermissionsService.check('approveBBC');
    this.bundle.canSignBBC = this.llPermissionsService.check('signBBC');

    if (!this.bundle.canEditElements) {
      this.bundle.configLock = true;
    }
    if (!this.bundle.canEditRecords) {
      this.bundle.valueLock = true;
    }
    let parentElement = this.mainDiv.nativeElement.parentElement?.parentElement;
    this.bundle.parentW = parentElement.clientWidth;
    this.bundle.parentH = parentElement.clientHeight;
    this.bundle.spW = this.bundle.parentW - 20;
    this.bundle.spH = this.bundle.parentH - this.bundle.spY - 40;
    this.bundle.remainingW = this.bundle.parentW - this.bundle.remainingX;
    setTimeout(() => {
      this.fetchData();
      this.cdr.detectChanges();
    });
  }

  private initializeTooltipVisibility(): void {
    if (!this.bundle.records || this.bundle.records.length === 0) {
      console.warn('No records available to initialize tooltip visibility');
      return;
    }
    this.bundle.records.forEach(record => {
      this.tooltipVisibility[record.LOANELEMENTID] = false;
    });
  }

  public sortGroupsByOrder(groups: LoanRecordGroup[]): LoanRecordGroup[] {
    return [...groups].sort((a, b) => a.GROUPORDER - b.GROUPORDER);
  }

  public getRecordsForGroup(groupId: number | undefined): LoanRecordElement[] {
    if (typeof groupId !== 'number') return [];
    return this.groupRecords[groupId] || [];
  }

  public getRecordCountForGroup(groupId: number | undefined): number {
    if (!this.bundle.records || groupId === undefined) return 0;
    return this.bundle.records.filter(record => record.LOANGROUPID === groupId).length;
  }

  private fetchData(): void {
    this.bundle.LOANMODELBBCRECORDID = Number(this.llModelsService.getActiveLOANMODELBBCRECORDID()) || 0;
    this.llModelsService.NG_LL_model_loanMgmt_modelElementsIncluded_get(this.bundle.function, this.bundle.BBC_throughDate_num, this.bundle.BBC_MONTHENDDATE_NUM, (records: LoanRecordElement[]) => {

      console.log(records)

      const periodEndRecord = records.find(r => r.LOANELEMENTID === 36);
      if (periodEndRecord && periodEndRecord.ELEMENTVALUE) {
        console.log(periodEndRecord.ELEMENTVALUE)
      }

      records.forEach(record => {
        if (record.LOANELEMENTID === 0) return; // skip placeholders

        // Only convert dates for actual date-type fields (not dropdowns)
        if (record.ELEMENTVALUETYPE === 'date') {
          if (record.ELEMENTVALUE) {
            const rawValue = record.ELEMENTVALUE.toString().trim();
            if (/^\d{8}$/.test(rawValue)) {

              const year = rawValue.substring(0, 4);
              const month = rawValue.substring(4, 6);
              const day = rawValue.substring(6, 8);
              const formatted = `${year}-${month}-${day}`;              
              const dateObj = new Date(formatted);
              if (!isNaN(dateObj.getTime())) {
                record.ELEMENTVALUE = formatted;
              } else {
                record.ELEMENTVALUE = '';
              }
            } else {
              const date = new Date(rawValue);
              if (!isNaN(date.getTime())) {
                record.ELEMENTVALUE = date.toISOString().split('T')[0];
              } else {
                record.ELEMENTVALUE = '';
              }
            }
          } else {
            record.ELEMENTVALUE = '';
          }
        } else if (record.ELEMENTVALUETYPE !== 'dropdown' && record.ELEMENTVALUETYPE !== 'none') {
          // Numeric parsing for non-date, non-dropdown fields
          record.ELEMENTVALUE = parseFloat(record.ELEMENTVALUE as any);
          if (isNaN(record.ELEMENTVALUE as number)) record.ELEMENTVALUE = 0;
        }
        // Dropdowns (including 119) keep their original string values here
      });

      //this.bundle.BBC_throughDate_num = '0';
      //this.bundle.BBC_MONTHENDDATE_NUM = '0';
      this.bundle.records = records;

      // Pre-compute dropdown options
      this.dropdownOptions = {};
      records.forEach(record => {
        if (record.ELEMENTVALUETYPE === 'dropdown' && record.DROPCHOICES) {
          this.dropdownOptions[record.LOANELEMENTID] = this.getDropdownOptions(record.DROPCHOICES);
        }
      });

      

      // ──────────────────────────────────────────────────────────────
      // For LOANELEMENTID 119: use FIRST value from DROPCHOICES
      // ──────────────────────────────────────────────────────────────
      // Inside fetchData(), after pre-computing dropdownOptions

      const monthEndRecord = records.find(r => r.LOANELEMENTID === 119);
      if (monthEndRecord && monthEndRecord.ELEMENTVALUE) {
        const rawValue = monthEndRecord.ELEMENTVALUE.toString().trim();

        if (/^\d{8}$/.test(rawValue)) {
          const year = rawValue.substring(0, 4);
          const month = rawValue.substring(4, 6);
          const day = rawValue.substring(6, 8);
          const formatted = `${month}/${day}/${year}`; // MM/DD/YYYY

          console.log("Converted LOANELEMENTID 119 from", rawValue, "to", formatted);

          // Set the formatted value
          monthEndRecord.ELEMENTVALUE = formatted;

          this.cdr.detectChanges();  // force Angular to update the view immediately

        } else {
          console.log(`LOANELEMENTID 119 value not in YYYYMMDD format: ${rawValue} (no conversion)`);
        }
      } else {
        console.log("No record or no value for LOANELEMENTID 119");
      }

      if (records.length > 0) {

        if (this.bundle.function === 'bbc') {

          if (records[0].BBCCLIENTSIGNATUREYESNO === 'Yes' || records[0].BBCLENDERAPPROVEDYESNO === 'Yes') {

            this.bundle.valueLock = true;

          } else if (this.bundle.canSignBBC === true && records[0].BBC_CLIENTSIG_REQUIREDYESNO === 'Yes' && records[0].BBCCLIENTSIGNATUREYESNO === 'No') {
            this.bundle.showClientSig = true;
          } else if (this.bundle.canApproveBBC === true && records[0].BBC_APPROVESIG_REQUIREDYESNO === 'Yes' && records[0].BBCLENDERAPPROVEDYESNO === 'No') {
            this.bundle.showApprovalSig = true;
          }



        }



        if (records.length > 0 && records[0].COLLATCONFIGMSG != "") {
          this.bundle.COLLATCONFIGMSG = records[0].COLLATCONFIGMSG
        }
        if (records.length > 0 && records[0].BBCLANGUAGE != "") {
          this.bundle.BBCLANGUAGE = records[0].BBCLANGUAGE
        }
        if (records.length > 0 && records[0].BBCAPPROVALLANGUAGE != "") {
          this.bundle.BBCAPPROVALLANGUAGE = records[0].BBCAPPROVALLANGUAGE
        }

        if (records.length > 0 && records[0].BBCLOGONAME != "") {
          this.bundle.BBCLOGONAME = "assets/" + records[0].BBCLOGONAME;
        }

      }

      this.formattedValues = {};

      records.forEach(record => {
        if (record.ELEMENTVALUETYPE != 'dropdown') { 
          this.formattedValues[record.LOANELEMENTID] = this.formatElementValue(record.ELEMENTVALUE, record.ELEMENTVALUETYPE);
        }
      });

      this.initializeTooltipVisibility();
      this.updateCalculatedElement();
      this.llModelsService.NG_LL_model_loanMgmt_modelGroups_get(this.bundle.function, (groups: LoanRecordGroup[]) => {
        this.bundle.groups = groups;
        this.groupRecords = {};
        if (this.bundle.records && this.bundle.groups) {
          const uniqueGroupIds = new Set(this.bundle.groups.map(group => group.LOANGROUPID));
          uniqueGroupIds.forEach(groupId => {
            const groupRecords = this.bundle.records!.filter(record => record.LOANGROUPID === groupId);
            this.groupRecords[groupId] = groupRecords;
          });
        }
        this.llModelsService.NG_LL_model_loanMgmt_modelElements_choices_get((elements: LoanElement[]) => {
          this.bundle.elements = elements;
          this.cdr.detectChanges();
        });
      });
      this.cdr.detectChanges();
    });
  }

  private mmddyyyyToYyyymmdd(dateStr: string): string {
    if (!dateStr) return '';

    const parts = dateStr.split('/');
    if (parts.length !== 3) return '';

    const [mm, dd, yyyy] = parts.map(s => s.trim().padStart(2, '0'));

    if (mm.length !== 2 || dd.length !== 2 || yyyy.length !== 4) {
      return '';
    }

    return yyyy + mm + dd;
  }

  public formatElementValue(value: number | string, type: string): string {
    if (type === 'dropdown') {
      //return value?.toString() || '';
    }
    if (type === 'none') {
      return '';
    }
    if (type === 'date') {
      if (value) {
        const date = new Date(value as any);
        if (!isNaN(date.getTime())) {
          return date.toISOString().split('T')[0];
        }
      }
      return 'Date Required';
    }
    let numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) numValue = 0;
    switch (type) {
      case 'dollars':
        const formatted = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(numValue);
        return formatted;
      case 'decimal':
        return numValue.toFixed(2);
      case 'integer':
        return Math.floor(numValue).toString();
      default:
        return numValue.toString();
    }
  }

  private updateCalculatedElement(): void {
    if (!this.bundle.records) return;
    const element71 = this.bundle.records.find(r => r.LOANELEMENTID === 71);
    const element68 = this.bundle.records.find(r => r.LOANELEMENTID === 68);
    if (element71 && element68 && element71.LOANGROUPID === 13) {
      const group13Records = this.bundle.records.filter(r => r.LOANGROUPID === 13 && r.LOANELEMENTID !== 71 && r.ELEMENTVALUETYPE !== 'date' && r.ELEMENTVALUETYPE !== 'none');
      const total = group13Records.reduce((sum, record) => {
        const value = typeof record.ELEMENTVALUE === 'string' ? parseFloat(record.ELEMENTVALUE) : record.ELEMENTVALUE;
        if (isNaN(value)) return sum;
        return record.ELEMENTPLUSMINUS === 'plus' ? sum + value : sum - value;
      }, 0);
      const value68 = typeof element68.ELEMENTVALUE === 'string' ? parseFloat(element68.ELEMENTVALUE) : element68.ELEMENTVALUE;
      const calculatedValue71 = (isNaN(value68) ? 0 : value68) + total;
      element71.ELEMENTVALUE = calculatedValue71;
      this.formattedValues[element71.LOANELEMENTID] = this.formatElementValue(element71.ELEMENTVALUE, element71.ELEMENTVALUETYPE);

      const element39 = this.bundle.records.find(r => r.LOANELEMENTID === 39);
      const element61 = this.bundle.records.find(r => r.LOANELEMENTID === 61);
      if (element61) {
        const value61 = typeof element61.ELEMENTVALUE === 'string' ? parseFloat(element61.ELEMENTVALUE) : element61.ELEMENTVALUE;
        const group21Records = this.bundle.records.filter(r => r.LOANGROUPID === 21 && r.LOANELEMENTID !== 39 && r.LOANELEMENTID !== 61 && r.ELEMENTVALUETYPE !== 'date' && r.ELEMENTVALUETYPE !== 'none');
        const total21 = group21Records.reduce((sum, record) => {
          const value = typeof record.ELEMENTVALUE === 'string' ? parseFloat(record.ELEMENTVALUE) : record.ELEMENTVALUE;
          if (isNaN(value)) return sum;
          if (record.ELEMENTPLUSMINUS === 'plus') return sum + value;
          if (record.ELEMENTPLUSMINUS === 'minus') return sum - value;
          return sum;
        }, isNaN(value61) ? 0 : value61);
        const calculatedValue39 = total21;
        if (element39) {
          element39.ELEMENTVALUE = calculatedValue39;
          this.formattedValues[element39.LOANELEMENTID] = this.formatElementValue(element39.ELEMENTVALUE, element39.ELEMENTVALUETYPE);
        }
        let outstandingLoanBalance39 = calculatedValue39;

        const element73 = this.bundle.records.find(r => r.LOANELEMENTID === 73);
        const element70 = this.bundle.records.find(r => r.LOANELEMENTID === 70);
        if (element73 && element70) {
          const value71 = typeof element71.ELEMENTVALUE === 'string' ? parseFloat(element71.ELEMENTVALUE) : element71.ELEMENTVALUE;
          const value70 = typeof element70.ELEMENTVALUE === 'string' ? parseFloat(element70.ELEMENTVALUE) : element70.ELEMENTVALUE;
          const calculatedValue73 = Math.min(isNaN(value70) ? 0 : value70, isNaN(value71) ? 0 : value71);
          element73.ELEMENTVALUE = calculatedValue73;
          this.formattedValues[element73.LOANELEMENTID] = this.formatElementValue(element73.ELEMENTVALUE, element73.ELEMENTVALUETYPE);

          const element75 = this.bundle.records.find(r => r.LOANELEMENTID === 75);
          if (element75) {
            const value39 = outstandingLoanBalance39;
            const calculatedValue75 = isNaN(value39) ? outstandingLoanBalance39 : value39;
            element75.ELEMENTVALUE = calculatedValue75;
            this.formattedValues[element75.LOANELEMENTID] = this.formatElementValue(element75.ELEMENTVALUE, element75.ELEMENTVALUETYPE);

            const element76 = this.bundle.records.find(r => r.LOANELEMENTID === 76);
            if (element76) {
              const value73 = typeof element73.ELEMENTVALUE === 'string' ? parseFloat(element73.ELEMENTVALUE) : element73.ELEMENTVALUE;
              const value75 = typeof element75.ELEMENTVALUE === 'string' ? parseFloat(element75.ELEMENTVALUE) : element75.ELEMENTVALUE;
              const calculatedValue76 = (isNaN(value73) ? 0 : value73) - (isNaN(value75) ? 0 : value75);
              element76.ELEMENTVALUE = calculatedValue76;
              this.formattedValues[element76.LOANELEMENTID] = this.formatElementValue(element76.ELEMENTVALUE, element76.ELEMENTVALUETYPE);

              const element74 = this.bundle.records.find(r => r.LOANELEMENTID === 74);
              const element54 = this.bundle.records.find(r => r.LOANELEMENTID === 54);
              if (element74 && element54 && element70) {
                const value75 = typeof element75.ELEMENTVALUE === 'string' ? parseFloat(element75.ELEMENTVALUE) : element75.ELEMENTVALUE;
                const value54 = typeof element54.ELEMENTVALUE === 'string' ? parseFloat(element54.ELEMENTVALUE) : element54.ELEMENTVALUE;
                const calculatedValue74 = (isNaN(value75) ? 0 : value75) + (isNaN(value54) ? 0 : value54);
                element74.ELEMENTVALUE = calculatedValue74;
                this.formattedValues[element74.LOANELEMENTID] = this.formatElementValue(element74.ELEMENTVALUE, element74.ELEMENTVALUETYPE);
                const value70 = typeof element70.ELEMENTVALUE === 'string' ? parseFloat(element70.ELEMENTVALUE) : element70.ELEMENTVALUE;
                if (!isNaN(calculatedValue74) && !isNaN(value70) && calculatedValue74 > value70) {
                  element74.ELEMENTNOTE = 'Excess of Commitment';
                } else {
                  element74.ELEMENTNOTE = '';
                }
                if (element54) {
                  const element72 = this.bundle.records.find(r => r.LOANELEMENTID === 72);
                  if (element72) {
                    const value76 = typeof element76.ELEMENTVALUE === 'string' ? parseFloat(element76.ELEMENTVALUE) : element76.ELEMENTVALUE;
                    const value54 = typeof element54.ELEMENTVALUE === 'string' ? parseFloat(element54.ELEMENTVALUE) : element54.ELEMENTVALUE;
                    const calculatedValue72 = (isNaN(value76) ? 0 : value76) - (isNaN(value54) ? 0 : value54);
                    element72.ELEMENTVALUE = calculatedValue72;
                    this.formattedValues[element72.LOANELEMENTID] = this.formatElementValue(element72.ELEMENTVALUE, element72.ELEMENTVALUETYPE);
                    if (!isNaN(calculatedValue72) && calculatedValue72 < 0) {
                      element54.ELEMENTNOTE = 'Excess of Availability';
                    } else {
                      element54.ELEMENTNOTE = '';
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    this.bundle.records.forEach(record => {
      this.formattedValues[record.LOANELEMENTID] = this.formatElementValue(record.ELEMENTVALUE, record.ELEMENTVALUETYPE);
    });
    this.cdr.detectChanges();
  }

  public onInputKeyUp(event: KeyboardEvent, recordId: number): void {
    const record = this.bundle.records?.find(r => r.LOANELEMENTID === recordId);
    if (!record || record.ELEMENTVALUETYPE === 'none' || record.LOANELEMENTID === 69) return;
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9.-]/g, '');
    const parsedValue = parseFloat(value) || 0;
    if (this.bundle.records) {
      record.ELEMENTVALUE = record.ELEMENTVALUETYPE === 'integer' ? Math.floor(parsedValue) : parsedValue;
      this.formattedValues[recordId] = this.formatElementValue(record.ELEMENTVALUE, record.ELEMENTVALUETYPE);
      if (/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]$/.test(event.key)) {
        this.bundle.saved = false;
        this.bundle.valuesChanged = true;
      }
      this.updateCalculatedElement();
      if (event.key === 'Enter') {
        const currentInput = event.target as HTMLInputElement;
        const form = currentInput.closest('div.group-list');
        if (form) {
          const inputs = Array.from(form.querySelectorAll('input.record-input, input.note-input, input.date-input')) as HTMLInputElement[];
          const currentIndex = inputs.indexOf(currentInput);
          if (currentIndex < inputs.length - 1) {
            inputs[currentIndex + 1].focus();
          } else {
            inputs[0].focus();
          }
        }
      }
    }
  }

  public onDateInputChange(event: Event, recordId: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (this.bundle.records) {
      const record = this.bundle.records.find(r => r.LOANELEMENTID === recordId);
      if (record) {
        record.ELEMENTVALUE = value;
        this.formattedValues[recordId] = this.formatElementValue(value, record.ELEMENTVALUETYPE);
        this.bundle.BBC_throughDate_num = value ? value.replace(/-/g, '') : '';
        this.cdr.detectChanges();
        this.fetchData();
      }
    }
  }

  public onNoteInputKeyUp(event: KeyboardEvent, recordId: number): void {
    const record = this.bundle.records?.find(r => r.LOANELEMENTID === recordId);
    if (!record || record.ELEMENTVALUETYPE === 'none') return;
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    if (this.bundle.records) {
      record.ELEMENTNOTE = value;
      if (/^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]$/.test(event.key)) {
        this.bundle.saved = false;
        this.bundle.valuesChanged = true;
      }
      if (event.key === 'Enter') {
        const currentInput = event.target as HTMLInputElement;
        const form = currentInput.closest('div.group-list');
        if (form) {
          const inputs = Array.from(form.querySelectorAll('input.record-input, input.note-input, input.date-input')) as HTMLInputElement[];
          const currentIndex = inputs.indexOf(currentInput);
          if (currentIndex < inputs.length - 1) {
            inputs[currentIndex + 1].focus();
          } else {
            inputs[0].focus();
          }
        }
      }
    }
  }

  public save(source): void {
    if (this.bundle.records && this.bundle.records.length > 0) {
      this.llModelsService.NG_LL_model_loanMgmt_modelElementValues_edit(
        this.handleSaveCallback.bind(this),
        source,
        this.bundle.function,
        this.bundle.records
      );
      this.formattedValues = {};
      this.bundle.records.forEach(record => {
        this.formattedValues[record.LOANELEMENTID] = this.formatElementValue(
          record.ELEMENTVALUE,
          record.ELEMENTVALUETYPE
        );
      });
    }
    this.cdr.detectChanges();
  }

  private handleSaveCallback(arr: any, source): void {
    this.bundle.saved = true;
    this.bundle.valuesChanged = false;
    this.bundle.configLock = true;
    this.bundle.valueLock = true;
    if (source === 'signature') {
      this.bundle.BBCSignatureName = arr[0].BBCCLIENTSIGNATURENAME;
    }
    this.cdr.detectChanges();
  }

  public showTooltip(event: MouseEvent, recordId: number): void {
    this.tooltipVisibility[recordId] = true;
    this.tooltipPosition = { x: event.clientX + 5, y: event.clientY + 5 };
  }

  public hideTooltip(recordId: number): void {
    this.tooltipVisibility[recordId] = false;
  }

  public edit(groupId: number, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const groupList = target.closest('.group-list') as HTMLElement;
    if (!groupList) {
      console.warn('Group list container not found for popover positioning');
      return;
    }
    const rect = groupList.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const clickY = event.clientY - rect.top;
    this.popoverPosition = {
      x: clickX,
      y: clickY
    };
    if (this.popoverGroupId === groupId && this.showPopover) {
      this.closePopover();
    } else {
      this.popoverGroupId = groupId;
      this.showPopover = true;
      this.isMouseInPopover = false;
      this.cdr.detectChanges();
    }
  }

  public closePopover(): void {
    this.showPopover = false;
    this.popoverGroupId = null;
    this.cdr.detectChanges();
  }

  public onPopoverMouseOver(): void {
    this.isMouseInPopover = true;
  }

  public onPopoverMouseOut(event: MouseEvent, groupId: number): void {
    const relatedTarget = event.relatedTarget as Node;
    const popover = (event.currentTarget as HTMLElement);
    if (popover && (!relatedTarget || !popover.contains(relatedTarget))) {
      this.isMouseInPopover = false;
      if (this.popoverGroupId === groupId) {
        this.closePopover();
      }
    }
  }

  public isElementInRecords(loanElementId: number, loanGroupId: number): boolean {
    return this.bundle.records?.some(record =>
      record.LOANELEMENTID === loanElementId && record.LOANGROUPID === loanGroupId
    ) || false;
  }

  public getElementsForGroup(groupId: number): LoanElement[] {
    if (!this.bundle.elements || !this.bundle.records) return [];
    return this.bundle.elements.filter(element => {
      if (element.LOANGROUPID !== groupId) return false;
      const record = this.bundle.records!.find(
        record => record.LOANELEMENTID === element.LOANELEMENTID && record.LOANGROUPID === element.LOANGROUPID
      );
      return !record || record.ELEMENTREQUIREDYESNO !== 'Yes';
    });
  }

  public handlePopoverClick(singleElementYesNo: 'Yes' | 'No'): void {
    if (singleElementYesNo === 'Yes') {
      this.closePopover();
    }
  }

  private createNewRecordElement(loanElementId: number, loanGroupId: number): LoanRecordElement {
    const element = this.bundle.elements?.find(e => e.LOANELEMENTID === loanElementId && e.LOANGROUPID === loanGroupId);
    const newRecord: LoanRecordElement = {
      LOANELEMENTID: element?.LOANELEMENTID ?? this.tempRecordIdCounter--,
      LOANGROUPID: element?.LOANGROUPID ?? loanGroupId,
      ELEMENTLABEL: element?.ELEMENTLABEL ?? 'Unknown',
      ELEMENTVALUE: 0,
      ELEMENTNOTE: '',
      ELEMENTDESCRIPTION: element?.ELEMENTDESCRIPTION ?? '',
      ELEMENTPLUSMINUS: element?.ELEMENTPLUSMINUS ?? 'none',
      ELEMENTVALUETYPE: element?.ELEMENTVALUETYPE ?? 'decimal',
      ELEMENTREQUIREDYESNO: element?.ELEMENTREQUIREDYESNO ?? 'No',
      ELEMENTCANEDITYESNO: element?.ELEMENTCANEDITYESNO ?? 'Yes',
      BBC_CLIENTSIG_REQUIREDYESNO:'No',
      BBCCLIENTSIGNATUREYESNO: 'No',
      BBCCLIENTSIGNATURENAME: '',
      BBC_APPROVESIG_REQUIREDYESNO: 'No',
      BBCLENDERAPPROVEDYESNO: 'No',
      BBCLENDERAPPROVALNAME: '',
      ELEMENTCODE: element?.ELEMENTCODE ?? '',
      THROUGHDATELIMIT: '',
      ELEMENTORDER: element?.ELEMENTORDER ?? 0,
      BBCLANGUAGE: '',
      BBCAPPROVALLANGUAGE: '',
      BBCLOGONAME: '',
      COLLATCONFIGMSG: '',
      CLIENTSIG: '',
      CLIENTTITLE: '',
      LOANMODELBBCRECORDID: 0,
      CLIENTSIGNINLLYESNO: 'No',
      LENDERAPPROVEINLLYESNO: 'No',
      DROPCHOICES: element?.DROPCHOICES,
    };

    if (newRecord.ELEMENTVALUETYPE === 'dropdown' && newRecord.DROPCHOICES) {
      this.dropdownOptions[newRecord.LOANELEMENTID] = this.getDropdownOptions(newRecord.DROPCHOICES);
    }

    return newRecord;
  }

  public onCheckboxClick(loanElementId: number, loanGroupId: number, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    if (isChecked) {
      const newRecord = this.createNewRecordElement(loanElementId, loanGroupId);
      if (!this.bundle.records) {
        this.bundle.records = [];
      }
      const group = this.bundle.groups.find(g => g.LOANGROUPID === loanGroupId);
      if (group && group.SINGLEELEMENTYESNO === 'Yes') {
        this.bundle.records = this.bundle.records.filter(record => record.LOANGROUPID !== loanGroupId);
      }
      this.bundle.records.push(newRecord);
      this.bundle.records = this.bundle.records.sort((a, b) => {
        if (a.LOANGROUPID === b.LOANGROUPID) {
          return (a.ELEMENTORDER || 0) - (b.ELEMENTORDER || 0);
        }
        return a.LOANGROUPID - b.LOANGROUPID;
      });
      this.groupRecords[loanGroupId] = this.bundle.records
        .filter(record => record.LOANGROUPID === loanGroupId)
        .sort((a, b) => (a.ELEMENTORDER || 0) - (b.ELEMENTORDER || 0));
      this.formattedValues[newRecord.LOANELEMENTID] = this.formatElementValue(newRecord.ELEMENTVALUE, newRecord.ELEMENTVALUETYPE);
      if (loanGroupId === 16) {
        this.updateCalculatedElement();
      }
    } else {
      if (this.bundle.records) {
        this.bundle.records = this.bundle.records.filter(record =>
          !(record.LOANELEMENTID === loanElementId && record.LOANGROUPID === loanGroupId)
        );
        this.groupRecords[loanGroupId] = this.bundle.records.filter(record => record.LOANGROUPID === loanGroupId);
        delete this.formattedValues[loanElementId];
        if (loanGroupId === 16) {
          this.updateCalculatedElement();
        }
      }
    }
    this.bundle.saved = false;
    this.cdr.detectChanges();
  }

  public lockUnlockConfiguration(): void {
    if (this.bundle.configLock === false) {
      this.bundle.configLock = true;
    } else {
      this.bundle.configLock = false;
    }
    this.cdr.detectChanges();
  }

  public lockUnlockValues(): void {
    if (this.bundle.valueLock === false) {
      this.bundle.valueLock = true;
    } else {
      this.bundle.valueLock = false;
    }
    this.cdr.detectChanges();
  }

  public openSignaturePopup(type): void {
    let user = this.llModelsService.getActiveUser();
    this.sigType = type;
    this.bundle.CONTACTFIRST = user.CONTACTFIRST;
    this.bundle.CONTACTLAST = user.CONTACTLAST;
    this.showSignaturePopup = true;
    this.signatureInputValue = '';
    setTimeout(() => {
      if (this.signatureInput) {
        this.signatureInput.nativeElement.focus();
      }
    }, 0);
    this.cdr.detectChanges();
  }

  public closeSignaturePopup(): void {
    this.showSignaturePopup = false;
    this.isMouseInSignaturePopup = false;
    this.signatureInputValue = '';
    this.cdr.detectChanges();
  }

  public isSignatureAndTitleValid() {
    if (this.signatureMatchesName() && this.bundle.titleInputValue.trim().length > 0) {
      this.bundle.sigAndTitle = true;
      this.bundle.records.forEach(record => {
        record.BBCCLIENTSIGNATUREYESNO = 'Yes';
      });
    } else {
      this.bundle.sigAndTitle = false;
      this.bundle.records?.forEach(record => {
        record.BBCCLIENTSIGNATUREYESNO = 'No';
      });
    }
    this.cdr.detectChanges();
  }

  public signatureMatchesName(): boolean {
    const fullName = `${this.bundle.CONTACTFIRST} ${this.bundle.CONTACTLAST}`.trim();
    return this.bundle.signatureInputValue.trim().toLowerCase() === fullName.toLowerCase();
  }

  public onSignatureInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.bundle.signatureInputValue = input.value;
    this.bundle.records.forEach(record => {
      record.CLIENTSIG = this.bundle.signatureInputValue;
    });
    this.isSignatureAndTitleValid();
  }

  public onTitleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.bundle.titleInputValue = input.value;
    this.bundle.records.forEach(record => {
      record.CLIENTTITLE = this.bundle.titleInputValue;
    });
    this.isSignatureAndTitleValid();
  }

  public signBBC(): void {
    this.bundle.signed_BBC = true;
    this.bundle.configLock = true;
    this.bundle.valueLock = true;
    this.showSignaturePopup = false;
    this.signatureInputValue = '';
    this.save('signature');
    this.cdr.detectChanges();
  }

  public approveBBCValues(): void {
    this.showSignaturePopup = false;
    this.llModelsService.NG_LL_model_loanMgmt_modelBBC_approve(
      this.handleApproveCallback.bind(this),
      this.bundle.records
    );
  }

  private handleApproveCallback(arr: any, source): void {
    this.bundle.saved = true;
    this.bundle.configLock = true;
    this.bundle.valueLock = true;
    this.bundle.approved_BBC = true;
    this.bundle.BBCApprovalName = arr[0].BBCAPPROVALNAME;
    this.cdr.detectChanges();
  }

  public deleteBBC(): void {
    this.showSignaturePopup = false;
    this.llModelsService.NG_LL_model_loanMgmt_modelBBC_delete(
      this.bundle.records
    );
  }

  public getDropdownOptions(dropChoices?: string): string[] {
    console.log("getDropdownOptions")

    if (!dropChoices || typeof dropChoices !== 'string') {
      return [];
    }
    return dropChoices
      .split(',')
      .map(item => item.trim())
      .filter(item => item.length > 0);
  }

  public onDropdownChange(event: Event, recordId: number): void {

    console.log("onDropdownChange")

    const select = event.target as HTMLSelectElement;
    const selectedValue = select.value;

    const record = this.bundle.records?.find(r => r.LOANELEMENTID === recordId);
    if (record) {
      record.ELEMENTVALUE = selectedValue;
      this.bundle.saved = false;
      this.bundle.valuesChanged = true;

      if (recordId === 119) {
        const monthEndDateNum = this.mmddyyyyToYyyymmdd(selectedValue);
        if (monthEndDateNum) {

          record.ELEMENTVALUE = monthEndDateNum;
          this.bundle.BBC_MONTHENDDATE_NUM = monthEndDateNum;
          this.cdr.detectChanges();
          this.fetchData();

          console.log(`Month-End Date updated to: ${monthEndDateNum}`);

        } else {
          console.warn(`Invalid date format selected for LOANELEMENTID 119: ${selectedValue}`);
        }
      }

      this.cdr.detectChanges();
    }
  }
}
